import { Rocket } from "lucide-react";
import { Modal } from "./Modal";

interface ProximamenteModalProps {
  planLabel: string;
  onClose: () => void;
}

export function ProximamenteModal({ planLabel, onClose }: ProximamenteModalProps) {
  return (
    <Modal onClose={onClose}>
      <div style={{ textAlign: "center" }}>
        <div style={{
          width: 64, height: 64, borderRadius: "50%", background: "rgba(196,154,138,0.15)",
          display: "grid", placeItems: "center", margin: "0 auto 16px",
        }}>
          <Rocket size={30} color="#C49A8A" strokeWidth={2} />
        </div>
        <h2 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 22, margin: "0 0 10px" }}>
          ¡Muy pronto! 🚀
        </h2>
        <p style={{ fontSize: 14.5, color: "var(--muted)", lineHeight: 1.6, margin: "0 0 26px" }}>
          Estamos terminando los últimos detalles para que puedas activar el Plan {planLabel} de forma
          segura. Te avisaremos por aquí y en nuestras redes en cuanto esté disponible.
        </p>
        <button onClick={onClose} className="btn btn-primary btn--full" style={{ marginBottom: 10 }}>
          Entendido
        </button>
        <a
          href="https://www.instagram.com/pzicodosis"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline btn--full"
          style={{ textDecoration: "none" }}
        >
          Síguenos en Instagram
        </a>
      </div>
    </Modal>
  );
}
